import z from 'zod'
import { decimalSchema } from '../../utils/schema'

export const incomeSchema = z.object({
  /** 取引ペア（存在する場合） */
  symbol: z.string(),
  /** 収益タイプ */
  incomeType: z.string(),
  /** 収益額 */
  income: decimalSchema,
  /** 資産 */
  asset: z.string(),
  /** 追加情報 */
  info: z.string(),
  /** 収益発生時間（UNIX時間・ミリ秒） */
  time: z.number(),
  /** トランザクションID（APIから数値または文字列で返される） */
  tranId: z.union([z.string(), z.number()]).transform(String),
  /** 取引ID（存在する場合） */
  tradeId: z.union([z.string(), z.number()]).transform(String).optional(),
})

export const responseSchema = z.array(incomeSchema)

export type Income = z.infer<typeof incomeSchema>
